import { useEffect, useState, type ReactNode } from "react";
import type { MusicTrack } from "@studio/shared";
import { apiRequest } from "../lib/api";
import type { TrackSongCode } from "../lib/songCodes";
import { SongCodeBox } from "./SongCodeBox";

function durationLabel(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
}

export function TrackCard({
  track,
  selected = false,
  actions,
  songCode,
  cover,
}: {
  track: MusicTrack;
  /** 노래 앨범 그림(2026-10-14) — 카드 맨 위에 그린다. 없으면 칸을 그리지 않는다. */
  cover?: ReactNode;
  selected?: boolean;
  actions?: ReactNode;
  /** 곡마다 노래 코드(026). 없으면 칸을 그리지 않는다. */
  songCode?: TrackSongCode | undefined;
}) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    void apiRequest<{ url: string }>(`/api/assets/${encodeURIComponent(track.asset_id)}/url`)
      .then((response) => {
        if (active) setUrl(response.url);
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [track.asset_id]);

  return (
    <article className={`track-card${selected ? " track-card-selected" : ""}`}>
      {cover}
      {/*
        🗑️ 원형 재생 아이콘과 웨이브 막대를 **삭제했다**(2026-08-14 jery QA).
           둘 다 눌러도 아무 일이 없는 장식이었고, 진짜 재생은 바로 아래 <audio controls> 가 한다.
           재생처럼 생긴 것이 두 개면 학생은 안 되는 쪽을 먼저 누른다.
      */}
      <div className="track-card-heading">
        <div>
          <h3>{track.title}</h3>
          <p>{track.style_sentence} · {durationLabel(track.duration_seconds)}</p>
        </div>
      </div>
      {url ? <audio className="track-audio" controls preload="none" src={url} /> : null}
      {failed ? <p className="track-error">재생 주소를 불러오지 못했어요.</p> : null}
      {songCode ? <SongCodeBox songCode={songCode} /> : null}
      {actions ? <div className="track-actions">{actions}</div> : null}
    </article>
  );
}

export function formatDuration(seconds: number): string {
  return durationLabel(seconds);
}
